// Dependencies:
//   jquery, activityManager, logger, **util**, **pageContext**
define('instrumentation/instrumentation', ['lib/jquery', 'instrumentation/activityManager', 'instrumentation/util', 'PageContext'],
    function ($, activityManager, util, pageContext) {
        return {
            start: function (batchSize, flushInterval, sessionCookieName, serverErrorCodes) {

                var self = this,
                    activityManagerOptions = {
                        getAppSubSystemNameFunc: function() { return self._overrideAppSubSystemName(pageContext.FeaturePilotFlag); },
                        getCustomerIdFunc: function() { return pageContext.cid; },
                        getAccountIdFunc: function() { return pageContext.aid; },
                        getUserIdFunc: function() { return pageContext.uid; },
                        getLcidFunc: function() { return pageContext.lcid; },
                        getRequestIdFunc: function() { return pageContext.requestId; },
                        getDeviceFunc: function() { return pageContext.device; },
                        getSessionIdFunc: function() { return pageContext.sessionId; },
                        detectError: function(respData) {
                            return self._detectError(respData, serverErrorCodes);
                        },
                        getScenarioName: function() { return pageContext.scenarioName ? pageContext.scenarioName : ''; }
                    };
                activityManager.init(activityManagerOptions);
            },

            _overrideAppSubSystemName: function(featurePilotFlag) {
                var appSubSystems = ["webui"];
                if (featurePilotFlag) {
                    if (featurePilotFlag.isAzMapsTrafficEnabled) {
                      appSubSystems.push("azmaps");
                    }
                }
                return appSubSystems.join(",");
            },

            _detectError: function(respData, serverErrorCodes) {
                var result = {
                    pass: true
                };

                if (respData && respData.Errors && respData.Errors[0] && respData.Errors[0].Code && $.isArray(serverErrorCodes) && $.inArray(respData.Errors[0].Code, serverErrorCodes) > -1) {
                    result.pass = false;
                    result.message = respData.Errors[0].Message;
                }
                return result;
            }
        };
});
